import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultDisabledUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultDisabledUsers');

export const accountSearchResultDisabledUsersActions = accountSearchResultDisabledUsersSlice.actions;

const accountSearchResultDisabledUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.disabledUsers.cache;
export const accountSearchResultDisabledUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.disabledUsers;
export const accountSearchResultDisabledUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultDisabledUsersCacheSelector,
    accountSearchResultStateSelector,
);
